import { Stack } from "@similarweb/ui-components/foundations";

import { TrafficSourceTabs, useSelectedTrafficSource } from "../../traffic-sources-tabs";

import { ShareOfChannelTrafficTable } from "./share-of-channel-traffic-table/ShareOfChannelTrafficTable";

export const ShareOfChannelTraffic = () => {
    const { value } = useSelectedTrafficSource();

    return (
        <Stack flexGrow="1">
            <TrafficSourceTabs />
            <ShareOfChannelTrafficTable trafficSource={value} />
        </Stack>
    );
};
